import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import SimpleHeader from "../../base/features/blocks/SimpleHeader";
import { apiService } from "../../base/service/service";
import ConcertBlock from "./ConcertBlock";

export default function Home() {
  const [concerts, setConcerts] = useState(null);
  useEffect(() => {
    getConcerts();
  }, []);
  function getConcerts() {
    apiService({ url: `api/events/list` }).then((data) => {
      if (data && data.success === 1) {
        setConcerts(data.data);
      }
    });
  }

  const handleOpenSamandehi = () => {
    window.open(
      "https://logo.samandehi.ir/Verify.aspx?id=395227&p=xlaopfvldshwuiwkuiwkjyoe",
      "Popup",
      "toolbar=no,scrollbars=no,location=no,statusbar=no,menubar=no,resizable=0,width=450,height=630,top=30"
    );
  };
  return (
    <div className="container-fluid px-0">
      <div className="row mx-0 p-2">
        {concerts ? (
          concerts.map((concert, c) => (
            <div className="col-6 col-sm-4 col-md-3 p-1">
              <ConcertBlock concert={concert} />
            </div>
          ))
        ) : (
          <div className="text-center py-3 mt-5">
            <Spinner
              size="md"
              className="align-middle text-main"
              animation="border"
            />
          </div>
        )}
      </div>
      <div className="mt-5">
        <img
          referrerpolicy="origin"
          id="rgvjsizpapfunbqenbqejzpe"
          style={{ cursor: "pointer" }}
          onClick={handleOpenSamandehi}
          alt="logo-samandehi"
          src="https://logo.samandehi.ir/logo.aspx?id=395227&p=qftibsiyujynodrfodrfyndt"
        />
      </div>
    </div>
  );
}
